import customAxios from './axiosConfig'
import store from '../../store'

const UserService = {
  retrieveCurrent (params) {
    var url = window.Urls['user-detail'](store.getters['main/getUserId'])
    return customAxios.get(url, { params: params, useCache: true })
  },
  updateEmail (data) {
    var url = window.Urls["user_update_email"](store.getters['main/getUserId'])
    return customAxios.post(url, data)
  },
  deleteAccount (data) {
    var url = window.Urls["user_delete_account"](store.getters['main/getUserId'])
    return customAxios.post(url, data)
  },
  changePassword (data) {
    var url = window.Urls["user_change_password"]()
    return customAxios.post(url, data)
  }
}

export default UserService;